import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./auth/auth.guard";
import { NavComponent } from "./nav/nav.component";
import { NotFoundComponent } from "./shared/components/not-found/not-found.component";
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "enabled",
  anchorScrolling: "enabled",
  scrollOffset: [0, 0],
};
const routes: Routes = [
  {
    path: "",
    component: NavComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then(
            (mod) => mod.DashboardModule
          ),
      },
      {
        path: "autasks",
        loadChildren: () =>
          import("./indicators/autasks.module").then(
            (mod) => mod.AuTasksModule
          ),
      },
      {
        path: "corrections",
        loadChildren: () =>
          import("./indicators/collections.module").then(
            (mod) => mod.CollectionsModule
          ),
      },
      {
        path: "documents",
        loadChildren: () =>
          import("./documentation/documentation.module").then(
            (mod) => mod.DocumentationModule
          ),
      },
      {
        path: "users",
        loadChildren: () =>
          import("./users/users.module").then((mod) => mod.UsersModule),
      },
      {
        path: "teachers",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then(
            (mod) => mod.DashboardModule
          ),
      },
      {
        path: "admin",
        loadChildren: () =>
          import("./admin/admin.module").then((mod) => mod.AdminModule),
      },
      {
        path: "surveys",
        loadChildren: () =>
          import("./surveys/surveys.module").then((mod) => mod.SurveysModule),
      },
      {
        path: "reports",
        loadChildren: () =>
          import("./reports/reports.module").then((mod) => mod.ReportsModule),
      },
      {
        path: "dispute-resolution",
        loadChildren: () =>
          import("./dispute-resolution/dispute-resolution.module").then(
            (mod) => mod.DisputeResolutionModule
          ),
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: "public",
    loadChildren: () =>
      import("./public/public.module").then((mod) => mod.PublicModule),
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./auth/auth.module").then((mod) => mod.AuthModule),
  },
  {
    path: "signedforms",
    loadChildren: () =>
      import("./signed-forms/signed-forms.module").then(
        (mod) => mod.SignedFormsModule
      ),
  },
  {
    path: "dr-request",
    loadChildren: () =>
      import("./dispute-resolution/dr-request/dr-request.module").then(
        (mod) => mod.DRRequestModule
      ),
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
